import { PadSizeBase } from './base/pad-size-base';

export class PadSize extends PadSizeBase { }